namespace GeniuzPOS.Purchase {
    export enum ApproveFgonApptran {
        UnPost = 0,
        Posted = 1,
        inpro = 2,
        inprotrigger = 3
    }
    Serenity.Decorators.registerEnumType(ApproveFgonApptran, 'GeniuzPOS.Purchase.ApproveFgonApptran');
}
